export const SENTRY_IGNORED_ERRORS = [
    "Cannot read properties of null (reading 'clientWidth')",
    "Cannot read properties of null (reading 'addEventListener')",
];